'use client';

import { ConfigService } from '@axo/config';
import type { UnsecuredLoanConfig } from '@axo/config/@types/context/product-unsecured-loan-config.types';
import { parseQueryParams } from '../../../utils/parseQueryParams';

/**
 * create form default values - Applied Amount, Loan Duration, Refinancing
 *
 * supports `@axo/site-one` and `@axo/white-label-host` (brand-aware embeds)
 *
 * 1. URL Query Param value
 * 2. CMS value
 * 3. Default from form Config value
 * 4. Should not be able to set a value that is out of range (min, max)
 */
export const createFormDefaultValues = () => {
  const queryParams = parseQueryParams();
  const amount = getDefaultValue('amount', queryParams);
  const duration = getDefaultValue('duration', queryParams);

  return {
    amount: Number(amount),
    duration: Number(duration),
  };
};

const getDefaultValue = (
  field: keyof UnsecuredLoanConfig,
  queryParams: Map<string, unknown>
) => {
  const configValue = ConfigService.get('product-unsecured-loan').config[field];
  const queryValue = queryParams.has(field) && queryParams.get(field);

  switch (typeof queryValue) {
    case 'string':
      return queryValue;
    case 'number':
      return Math.max(configValue.min, Math.min(queryValue, configValue.max));
    default:
      return configValue.default;
  }
};
